import { ILocalizable } from "infrastructure/localization";
import { INotification } from "infrastructure/notification";
import { IValidationIssue } from "infrastructure/validation";

import { ParentFlag } from "../shared/types/ParentFlag.types";

export interface IMessageItem {
  messageId: string;
  text: string;
  status: string;
  tokens: ITokenItem[];
  parentMessage: string;
  isParentMessage?: boolean;
  version: number;
}

export interface ITokenItem {
  name: string;
  description?: string;
  type?: string;
}

export interface IMessagesGetRequest {
  messageId?: string;
  text?: string;
  status?: ILocalizable;
  parent: ParentFlag | undefined;
}

export interface IMessagesFilter {
  messageId?: string;
  text?: string;
  statuses: ILocalizable[];
  parents: ILocalizable[];
  displayTokens: boolean;
}

export interface IMessagesSearchQuery {
  messageId?: string;
  text?: string;
  selectedStatus?: ILocalizable;
  selectedParent?: ILocalizable;
  displayTokens: boolean;
}

export interface IMessagesUploadingState {
  uploadingProcessing: boolean;
  uploadCompleted: boolean;
  validationIssues?: IValidationIssue[];
}

export interface IMessagesManagerGrid {
  gridData: IMessageItem[];
  selected: string;
  isSearched: boolean;
}

export interface IMessagesState {
  filter: IMessagesFilter;
  grid: IMessagesManagerGrid;
  notifications: INotification[];
  isLoading: boolean;
  isExportDisabled: boolean;
  searchQuery: IMessagesSearchQuery;
}

export const getInitialMessagesUploadingState = (): IMessagesUploadingState => ({
  uploadingProcessing: false,
  uploadCompleted: false
});

export const getInitialMessagesState = (): IMessagesState => ({
  filter: { messageId: "", text: "", parents: [], statuses: [], displayTokens: false },
  grid: { gridData: [], selected: "", isSearched: false },
  notifications: [],
  isLoading: false,
  isExportDisabled: true,
  searchQuery: { messageId: "", text: "", selectedParent: undefined, selectedStatus: undefined, displayTokens: false }
});
